var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgVector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 28",
    width: 25,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "img_vector-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { opacity: .5;fill: #111111 } \r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m31.4 0.7c0.4 0.4 0.6 1 0.6 1.6v23.4c0 0.6-0.2 1.2-0.6 1.6-0.5 0.5-1 0.7-1.6 0.7h-27.6c-0.6 0-1.1-0.2-1.6-0.7-0.4-0.4-0.6-1-0.6-1.6v-23.4c0-0.6 0.2-1.2 0.6-1.6 0.5-0.5 1-0.7 1.6-0.7h27.6c0.6 0 1.1 0.2 1.6 0.7zm-29.4 1.3q-0.1 0.1-0.1 0.3v15.9l6.3-6.6c0.4-0.4 0.9-0.6 1.5-0.6 0.6 0 1.2 0.2 1.6 0.6l7 7.3q0 0 0.1 0.1 0 0 0.1 0 0.1 0 0.1 0 0.1-0.1 0.1-0.1l3.3-3.4c0.4-0.4 0.9-0.6 1.5-0.6 0.6 0 1.2 0.2 1.6 0.6l5 5.3v-18.5q0-0.2-0.1-0.3-0.1 0-0.2 0h-27.6q-0.1 0-0.2 0zm28 24q0.1-0.1 0.1-0.3v-2.2l-6.4-6.6q0 0-0.1-0.1 0 0-0.1 0 0 0-0.1 0 0 0.1-0.1 0.1l-3.2 3.4c-0.5 0.4-1 0.6-1.6 0.6-0.6 0-1.1-0.2-1.5-0.6l-7.1-7.3q0 0-0.1-0.1 0 0-0.1 0 0 0-0.1 0-0.1 0.1-0.1 0.1l-7.6 7.9v4.8q0 0.2 0.1 0.3 0.1 0 0.2 0h27.6q0.1 0 0.2 0zm-10.7-15.4q-0.2-0.2-0.4-0.5-0.1-0.3-0.1-0.7c0-0.4 0.2-0.8 0.5-1.1 0.3-0.3 0.7-0.5 1.1-0.5 0.4 0 0.8 0.2 1.1 0.5 0.3 0.3 0.5 0.7 0.5 1.1 0 0.5-0.2 0.9-0.5 1.2-0.3 0.3-0.7 0.5-1.1 0.5q-0.3 0-0.6-0.1-0.3-0.2-0.5-0.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgVector);
export default __webpack_public_path__ + "static/media/img_vector.5c85caeb11e4f39107ade9c709fa7741.svg";
export { ForwardRef as ReactComponent };